module.exports = __webpack_public_path__ + "img/spam-yellow.8f7072c1.png";